import * as angular from "angular";
import * as _ from "lodash";
import {EmailReportTemplateEnum} from "../types/email-report-template.enum";
import {RecurringType} from "../../commons/types/recurring.type";
import {CommonsService} from "../../commons/services/commons-service.service";
import {EmailReportTemplateFilterEnum} from "../types/email-report-type-filters.enum";
import {SiteFiltersType} from "../../commons/types/site-filters.type";
import {TeamsRequestsService} from "../../teams/services/teams-requests.service";
import {EmailReportRecurringEnum} from "../types/email-report-recurring.enum";
import {SettingsRequestsService} from "./settings-requests.service";

export class PreferencesDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $log, private $preferences, private moment, private commonsConstants,
              private commonsService: CommonsService, private teamsRequestsService: TeamsRequestsService, private $window,
              private settingsRequestsService: SettingsRequestsService) {
  }

  editPreferencesProperty(event, property, programs?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-preferences-dialog.tmpl.html').default,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.copy = angular.copy(property);

        $scope.programs = programs;
        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        // ******************************
        // External methods
        // ******************************

        $scope.onChangeProperty = (property) => {
          $scope.copy = property;
        }

        $scope.doUpdate = (payloadToSend) => {
          $scope.loading = true;
          self.$preferences().$post([payloadToSend])
            .then((updatedElement) => {
              $scope.loading = false;
              self.$mdDialog.hide(updatedElement);
            })
            .catch((error) => {
                self.$log.error('Error while updating preferences value, preferencesDialogService@editPreferencesProperty: \n' + error);
              }
            );
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const payloadToSend = angular.copy($scope.copy);

              if (payloadToSend && _.isEqual(payloadToSend.valueType, 'Date')) {
                payloadToSend.value = JSON.stringify(self.moment(payloadToSend.value).valueOf());
              }

              $scope.doUpdate(payloadToSend);
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> editPreferencesProperty@editPreferencesProperty@submit')
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  metadataForm(event?, holder?, metadata?) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/metadata-form-dialog.tmpl.html').default,
      controller: function ($scope) {

        $scope.action = metadata ? 'Update' : 'Create';
        $scope.holder = holder;
        $scope.metadataPayload = metadata ? angular.copy(metadata) : {
          key: undefined,
          title: undefined,
          fieldOptions: undefined,
          active: false,
          editable: false,
          holder: holder // OMS, SERVICE, TASK
        }

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        $scope.onEditableChange = (editable) => {
          $scope.metadataPayload.editable = editable;
          $scope.metadataPayload.fieldOptions = !editable ? undefined : [];
        }

        $scope.onOptionsChange = (options) => {
          $scope.metadataPayload.fieldOptions = options?.length ? options : undefined;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.metadataPayload);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  changeSiteFlavorDialog(event, flavors, selectedFlavorId) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/change-site-flavor-dialog.html').default,
      controller: function ($scope) {

        $scope.flavors = flavors;
        $scope.selectedFlavorId = selectedFlavorId;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          self.$mdDialog.hide($scope.selectedFlavorId);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });

  }

  createEmailReportConfiguration(excludedEmailReportTypes?, header?, includeScheduleTime?, isUser?, branchIds?, userTeams?) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/email-report-configuration-template.html').default,
      controller: function ($scope, IAMPermissions) {

        $scope.headerTitle = header || 'Create email report configuration';
        $scope.includeScheduleTime = includeScheduleTime;
        $scope.isUser = isUser;
        $scope.branchIds = branchIds;
        $scope.excludedEmailReportTypes = excludedEmailReportTypes;
        $scope.siteFiltersType = SiteFiltersType;
        $scope.emailReportTemplateFilterEnum = EmailReportTemplateFilterEnum;
        $scope.scheduleTime = [{
          emailReportScheduledHour: undefined,
          emailReportScheduledMinutes: undefined
        }];

        const allEmailTypes = Object.values(EmailReportTemplateEnum);
        if (isUser) {
          $scope.emailReportTypes = [];
          self.settingsRequestsService.getEmailReportConfiguration()
            .then(siteConfigs => {
              const openAndActiveTypes = siteConfigs
                .filter(emailReport => emailReport.active && emailReport.visibleToAdmin)
                .map(emailReport => emailReport.emailReportType);

              $scope.emailReportTypes = _.filter(allEmailTypes, (type: EmailReportTemplateEnum) => {
                const isTeamReport = (type === EmailReportTemplateEnum.TeamsAgentWorkloadReport) || (type === EmailReportTemplateEnum.TeamsWorkloadReport);
                const hasPermission = IAMPermissions.hasPermission('teams.list') || !isTeamReport;
                return hasPermission && openAndActiveTypes.includes(type);
              });
            });
        } else if (IAMPermissions.hasPermission('teams.list')) {
          $scope.emailReportTypes = allEmailTypes;
        } else {
          $scope.emailReportTypes = _.filter(allEmailTypes, (t: EmailReportTemplateEnum) => {
            return (t !== EmailReportTemplateEnum.TeamsAgentWorkloadReport) && (t !== EmailReportTemplateEnum.TeamsWorkloadReport);
          });
        }

        if (isUser && userTeams) {
          $scope.userTeamOptionsWrapper = {
            list: userTeams?.map(t => {
              return {id: t.id, name: t.name}
            }), propertyRef: 'name'
          }
        }

        $scope.addScheduleTime = () => {
          if ($scope.scheduleTime.length < 6) {
            $scope.scheduleTime.push({
              emailReportScheduledHour: undefined,
              emailReportScheduledMinutes: undefined
            });
          }
        };

        $scope.removeScheduleTime = (index) => {
          if ($scope.scheduleTime.length > 1) {
            $scope.scheduleTime.splice(index, 1);
          }
        };

        $scope.canAddMoreScheduleTimes = () => {
          return $scope.scheduleTime.length < 6;
        };

        $scope.emailReportConfiguration = {
          emailReportType: undefined,
          active: undefined,
          visibleToAdmin: undefined,
          entityFilter: {
            branchIds: branchIds,
            teamIds: undefined
          }
        };

        $scope.recurringTypes = RecurringType;
        $scope.recurringType = RecurringType.DAILY;
        $scope.days = angular.copy(self.commonsConstants.daysCheckboxConfig);

        $scope.isDaysSelected = () => {
          return _.find($scope.days, (d) => {
            return !!d.enabled;
          })
        }

        $scope.onSelectRecurring = (recurringType) => {

          if ($scope.recurringType === recurringType) {
            return;
          }
          $scope.recurringType = recurringType;

          if (recurringType === RecurringType.WEEKLY) {
            $scope.days = angular.copy(self.commonsConstants.daysCheckboxConfig);
          } else {
            $scope.days = undefined;
          }
        }

        $scope.onSelectEmailReportType = (emailReportType) => {
          $scope.emailReportConfiguration.emailReportType = emailReportType;
          $scope.recurringOptions = EmailReportRecurringEnum[emailReportType];
        }

        $scope.onBranchesSelect = (branchIds) => {
          $scope.emailReportConfiguration.entityFilter.branchIds = branchIds;
        }


        $scope.onTeamsSelect = (teamIds) => {
          $scope.emailReportConfiguration.entityFilter.teamIds = teamIds;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if (includeScheduleTime) {
                let weekDays = [];
                if ($scope.recurringType === RecurringType.WEEKLY) {
                  weekDays = Object.values($scope.days)
                    .filter((day: any) => day.enabled)
                    .map((day: any) => day.dayNumber);
                }
                // Generate cron expressions for each schedule time
                $scope.emailReportConfiguration.cronExpressions = $scope.scheduleTime.map(scheduleTime => {
                  return self.commonsService.generateCronExpression(
                    undefined,
                    scheduleTime.emailReportScheduledHour,
                    scheduleTime.emailReportScheduledMinutes,
                    $scope.recurringType,
                    weekDays
                  );
                });
              }
              if (isUser) {
                if ($scope.emailReportTemplateFilterEnum[$scope.emailReportConfiguration.emailReportType] === $scope.siteFiltersType.branchIds) {
                  $scope.emailReportConfiguration.entityFilter.teamIds = undefined;
                }
                if ($scope.emailReportTemplateFilterEnum[$scope.emailReportConfiguration.emailReportType] === $scope.siteFiltersType.teamIds) {
                  $scope.emailReportConfiguration.entityFilter.branchIds = undefined;
                }
              }
              self.$mdDialog.hide($scope.emailReportConfiguration);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editEmailReportConfiguration(emailReportConfiguration, excludedEmailReportTypes?, header?, includeScheduleTime?, isUser?, branchIds?, userTeams?) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/email-report-configuration-template.html').default,
      controller: function ($scope, IAMPermissions) {

        $scope.headerTitle = header || 'Edit email report configuration';
        $scope.includeScheduleTime = includeScheduleTime;
        $scope.isUser = isUser;
        $scope.branchIds = branchIds;
        $scope.excludedEmailReportTypes = excludedEmailReportTypes;
        $scope.emailReportTemplateFilterEnum = EmailReportTemplateFilterEnum;
        $scope.siteFiltersType = SiteFiltersType;
        $scope.emailReportConfiguration = emailReportConfiguration;

        const allEmailTypes = Object.values(EmailReportTemplateEnum);
        if (isUser) {
          $scope.emailReportTypes = [];
          self.settingsRequestsService.getEmailReportConfiguration().then(siteConfigs => {
            const openAndActiveTypes = siteConfigs
              .filter(c => c.active && c.visibleToAdmin)
              .map(c => c.emailReportType);

            $scope.emailReportTypes = _.filter(allEmailTypes, (t: EmailReportTemplateEnum) => {
              const isTeamReport = (t === EmailReportTemplateEnum.TeamsAgentWorkloadReport) || (t === EmailReportTemplateEnum.TeamsWorkloadReport);
              const hasPermission = IAMPermissions.hasPermission('teams.list') || !isTeamReport;
              return hasPermission && openAndActiveTypes.includes(t);
            });
          });
        } else if (IAMPermissions.hasPermission('teams.list')) {
          $scope.emailReportTypes = allEmailTypes;
        } else {
          $scope.emailReportTypes = _.filter(allEmailTypes, (t: EmailReportTemplateEnum) => {
            return (t !== EmailReportTemplateEnum.TeamsAgentWorkloadReport) && (t !== EmailReportTemplateEnum.TeamsWorkloadReport);
          });
        }

        $scope.recurringTypes = RecurringType;
        $scope.recurringOptions = EmailReportRecurringEnum[emailReportConfiguration.emailReportType];

        if (isUser && userTeams) {
          $scope.userTeamOptionsWrapper = {
            list: userTeams?.map(t => {
              return {id: t.id, name: t.name}
            }), propertyRef: 'name'
          }
        }

        $scope.isDaysSelected = () => {
          return _.find($scope.days, (d) => {
            return !!d.enabled;
          })
        }

        $scope.onSelectRecurring = (recurringType) => {
          if ($scope.recurringType === recurringType) {
            return;
          }
          $scope.recurringType = recurringType;

          if (recurringType === RecurringType.WEEKLY) {
            $scope.days = angular.copy(self.commonsConstants.daysCheckboxConfig);
          } else {
            $scope.days = undefined;
          }
        }

        $scope.onSelectEmailReportType = (emailReportType) => {
          $scope.emailReportConfiguration.emailReportType = emailReportType;
          $scope.recurringOptions = EmailReportRecurringEnum[emailReportType];
        }

        $scope.onBranchesSelect = (branchIds) => {
          if (!$scope.emailReportConfiguration.entityFilter) {
            $scope.emailReportConfiguration.entityFilter = {}
          }
          $scope.emailReportConfiguration.entityFilter.branchIds = branchIds;
        }

        $scope.onTeamsSelect = (teamIds) => {
          if (!$scope.emailReportConfiguration.entityFilter) {
            $scope.emailReportConfiguration.entityFilter = {}
          }
          $scope.emailReportConfiguration.entityFilter.teamIds = teamIds;
        }

        $scope.addScheduleTime = () => {
          if ($scope.scheduleTime.length < 6) {
            $scope.scheduleTime.push({
              emailReportScheduledHour: undefined,
              emailReportScheduledMinutes: undefined
            });
          }
        };

        $scope.removeScheduleTime = (index) => {
          if ($scope.scheduleTime.length > 1) {
            $scope.scheduleTime.splice(index, 1);
          }
        };

        $scope.canAddMoreScheduleTimes = () => {
          return $scope.scheduleTime.length < 6;
        };

        // const cronExpressions = Array.isArray($scope.emailReportConfiguration.cronExpression)
        //   ? $scope.emailReportConfiguration.cronExpression
        //   : [$scope.emailReportConfiguration.cronExpression];

        // Initialize with empty array if no cron expressions
        if (!!includeScheduleTime) {
          if ($scope.emailReportConfiguration.cronExpressions.length === 0) {
            $scope.scheduleTime = [{
              emailReportScheduledHour: undefined,
              emailReportScheduledMinutes: undefined
            }];
          } else {
            // Map cron expressions to schedule time objects
            $scope.scheduleTime = $scope.emailReportConfiguration.cronExpressions.map(cronExpression => {
              const parsedCronExpression = self.commonsService.parseCronExpression(cronExpression);
              return {
                emailReportScheduledHour: parsedCronExpression.cronHours,
                emailReportScheduledMinutes: parsedCronExpression.cronMinutes,
              };
            });
          }
          // Use the first cron expression for recurring type and days
          const firstParsedCronExpression = self.commonsService.parseCronExpression($scope.emailReportConfiguration.cronExpressions[0]);
          $scope.recurringType = firstParsedCronExpression.recurringType;

          $scope.days = angular.copy(self.commonsConstants.daysCheckboxConfig)

          Object.values($scope.days).forEach((day: any) => {
            day.enabled = firstParsedCronExpression.selectedWeekDays.includes(day.dayNumber);
          });
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if (includeScheduleTime) {
                let weekDays = [];
                if ($scope.recurringType === RecurringType.WEEKLY) {
                  weekDays = Object.values($scope.days)
                    .filter((day: any) => day.enabled)
                    .map((day: any) => day.dayNumber);
                }
                // Generate cron expressions for each schedule time
                $scope.emailReportConfiguration.cronExpressions = $scope.scheduleTime.map(scheduleTime => {
                  return self.commonsService.generateCronExpression(
                    undefined,
                    scheduleTime.emailReportScheduledHour,
                    scheduleTime.emailReportScheduledMinutes,
                    $scope.recurringType,
                    weekDays
                  );
                })
              }
              if (isUser) {
                if ($scope.emailReportTemplateFilterEnum[$scope.emailReportConfiguration.emailReportType] === $scope.siteFiltersType.branchIds) {
                  $scope.emailReportConfiguration.entityFilter.teamIds = undefined;
                }
                if ($scope.emailReportTemplateFilterEnum[$scope.emailReportConfiguration.emailReportType] === $scope.siteFiltersType.teamIds) {
                  $scope.emailReportConfiguration.entityFilter.branchIds = undefined;
                }
              }
              self.$mdDialog.hide($scope.emailReportConfiguration);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  // private _smsScheduleTimeString(smsScheduleHours, smsScheduleMinutes) {
  //   let hours, minutes;
  //   //HOURS
  //   if (isNaN(smsScheduleHours) || _.isNull(smsScheduleHours)) {
  //     hours = "00"
  //   } else if (smsScheduleHours < 10) {
  //     hours = 0 + smsScheduleHours.toString();
  //   } else {
  //     hours = smsScheduleHours.toString();
  //   }
  //   //Minutes
  //   if (isNaN(smsScheduleMinutes) || _.isNull(smsScheduleMinutes)) {
  //     minutes = "00"
  //   } else if (smsScheduleMinutes < 10) {
  //     minutes = 0 + smsScheduleMinutes.toString();
  //   } else {
  //     minutes = smsScheduleMinutes.toString();
  //   }
  //
  //   return hours + ":" + minutes;
  // }


}

angular
  .module('bringoz.admin.site-preferences')
  .service('preferencesDialogService', PreferencesDialogService);
